import ApolloClient, { createNetworkInterface, toIdValue } from 'apollo-client';
import config from '../config';

const networkInterface = createNetworkInterface({
    uri: config.apiBaseURL + '/graphql',
    opts: {
        credentials: 'include'
    }
});

const apolloClient = new ApolloClient({
    networkInterface,
    dataIdFromObject: o => o.id,
    customResolvers: {
        Query: {
            item: (_, args) => toIdValue(apolloClient.dataIdFromObject({ id: args.itemId })),
        }
    },
});

export default apolloClient;



// WEBPACK FOOTER //
// ./src/services/apolloClient.js